import { SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { useLocation, Link } from 'react-router-dom';

const routeTitles: Record<string, string> = {
  '/portal': 'Dashboard',
  '/portal/reports': 'Reports',
  '/portal/invoices': 'Invoices',
  '/portal/releases': 'Releases',
  '/portal/mastering': 'Mastering',
  '/portal/contracts': 'Contracts',
  '/portal/files': 'Files',
  '/portal/support': 'Support',
  '/portal/settings': 'Settings',
  '/portal/admin/users': 'User Management',
  '/portal/admin/organizations': 'Organizations',
};

export function PortalHeader() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  const getPageTitle = () => {
    return routeTitles[location.pathname] ?? 'Portal';
  };

  const isAdminRoute = pathSegments.includes('admin');

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 border-b bg-background px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 h-4" />
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/portal">Portal</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {isAdminRoute && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/portal/admin/users">Admin</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {location.pathname !== '/portal' && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{getPageTitle()}</BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </header>
  );
}
